import React from 'react';
import { useParams } from 'react-router-dom';

import { useSuperHubStore } from '@core/store';

import type { SuperHubRouteParams } from '@routes/SuperHub/types';

import { CollapsedStateProvider } from '../CollapsedState';
import { ConfirmDeletionProvider } from '../ConfirmDeletion';

import { SidebarNavContextProvider } from './Context';
import { SidebarNavDefinitions } from './Definitions';
import { SidebarNavErrorStatus } from './ErrorStatus';
import { SidebarNavList } from './List';
import { SidebarNavRoot } from './Root';

export interface SidebarNavTreeProps {
  className?: string;
}

export const SidebarNavTree = React.memo(function SidebarNavTree({ className }: SidebarNavTreeProps) {
  const { section } = useParams<SuperHubRouteParams>();
  const [categories, totalUnrenderable] = useSuperHubStore(s => [s.sidebar.data, s.sidebar.totalUnrenderable]);

  return (
    <SidebarNavContextProvider>
      <SidebarNavRoot className={className}>
        <SidebarNavErrorStatus totalUnrenderable={totalUnrenderable} />
        {section === 'reference' && <SidebarNavDefinitions />}
        <ConfirmDeletionProvider>
          <CollapsedStateProvider>
            <SidebarNavList data={categories} />
          </CollapsedStateProvider>
        </ConfirmDeletionProvider>
      </SidebarNavRoot>
    </SidebarNavContextProvider>
  );
});
